<p>Examples of usages of components from the MarketPro library</p>

<h2>Primary Button</h2>
<p>Styled with directive</p>
<button class="mpro-btn" color="blue" hue="300" mproButtton>Create</button>
<button class="mpro-btn" color="apricot" hue="500" mproButtton>Create</button>
<button class="mpro-btn" color="blue" hue="300" mproButtton [disabled]="true">Disabled</button>
<button class="mpro-btn" color="red" hue="700" mproButtton="primary">Delete</button>
<br>
<p>Styled with generated classes</p>
<button class="mpro-btn mpro-btn-primary">Create</button>
<button class="mpro-btn mpro-btn-primary-apricot">Warning</button>
<button class="mpro-btn mpro-btn-primary" disabled>Disabled</button>
<br>
<hr>
<h2>Secondary Button</h2>
<p>Styled with directive</p>
<button class="mpro-btn" color="blue" hue="300" mproButtton="secondary">Create</button>
<button class="mpro-btn" color="blue" hue="300" mproButtton="secondary" [disabled]="true">Disabled</button>
<br>
<p>Styled with generated classes</p>
<button class="mpro-btn mpro-btn-secondary">Create</button>
<button class="mpro-btn mpro-btn-secondary-green">Success</button>
<button class="mpro-btn mpro-btn-secondary" disabled>Disabled</button>
<br>
<hr>
<h2>Tertiary Button</h2>
<p>Styled with directive</p>
<button class="mpro-btn" color="blue" hue="300" mproButtton="tertiary">Create</button>
<button class="mpro-btn" color="blue" hue="300" mproButtton="tertiary" [disabled]="true">Disabled</button>
<br>
<p>Styled with generated classes</p>
<button class="mpro-btn mpro-btn-tertiary">Create</button>
<button class="mpro-btn mpro-btn-tertiary-red">Error</button>
<button class="mpro-btn mpro-btn-tertiary" disabled>Disabled</button>
<br>
<hr>
<h2>Button Group</h2>

<!-- TODO replace the normal button in the group with radio buttons when they get added.
  This will take advatange of the static styles which will improve performance.
-->
<mpro-button-group>
  <button class="mpro-btn" color="blue" hue="300" mproButtton="secondary">Button 1</button>
  <button class="mpro-btn" color="red" hue="500" mproButtton="secondary">Button 2</button>
  <button class="mpro-btn" color="green" hue="700" mproButtton="secondary">Button 3</button>
</mpro-button-group>
<br>
<hr>

<h2>Accordion</h2>
<mpro-accordion class="light-primary" title="Title" [primary]="true">
  <p>The accordion component</p>
</mpro-accordion>
<br>
<hr>

<h2>Radio Button Group</h2>
<p>Radio Button Group Horizontal</p>
<mpro-radio-group value="Option 1" [dark]="false" [disabled]="true">
  <mpro-radio-button label="Option 1" value="Option 1"></mpro-radio-button>
  <mpro-radio-button label="Option 2" value="Option 2"></mpro-radio-button>
</mpro-radio-group>
<p>Radio Button Group Vertical</p>
<mpro-radio-group value="Option 1" alignment="vertical" [dark]="false">
  <mpro-radio-button label="Option 1" value="Option 1"></mpro-radio-button>
  <mpro-radio-button label="Option 2" value="Option 2"></mpro-radio-button>
</mpro-radio-group>
<br>
<hr>

<h2>Checkbox</h2>
<mpro-checkbox [(ngModel)]="checked" label="Option" [dark]="false" [disabled]="false"></mpro-checkbox>
<br>
<hr>

<h2>Toggle Switch</h2>
<mpro-toggle-switch label="Option"></mpro-toggle-switch>
<br>
<hr>

<h2>Tag</h2>
<div [ngStyle]="{'display': 'flex', 'justify-content': 'space-around', 'width': '600px'}">
  <mpro-tag [removeIcon]="true">Tag</mpro-tag>
  <mpro-tag [removeIcon]="true" color="green">Tag</mpro-tag>
  <mpro-tag [removeIcon]="true" color=apricot>Tag</mpro-tag>
  <mpro-tag [removeIcon]="true" color="red">Tag</mpro-tag>
  <mpro-tag [removeIcon]="true" color="gray">Tag</mpro-tag>
  <mpro-tag color="blue">Tag</mpro-tag>
  <mpro-tag color="green">Tag</mpro-tag>
  <mpro-tag color="apricot">Tag</mpro-tag>
  <mpro-tag color="red">Tag</mpro-tag>
  <mpro-tag color="gray">Tag</mpro-tag>
</div>
<br>
<hr>

<h2>Notification</h2>
<mpro-notification-wrapper direction="horizontal" [notifications]="notifications"></mpro-notification-wrapper>
<br>
<hr>

<br>
<hr>

<h2>Tooltips</h2>
<div [ngStyle]="{'display': 'flex'}">
  <mpro-tooltip [options]="chartTooltip"></mpro-tooltip>
  <mpro-tooltip [options]="mapTooltip"></mpro-tooltip>
  <mpro-tooltip [options]="interactiveTooltip"></mpro-tooltip>
  <mpro-tooltip [options]="simpleTooltip"></mpro-tooltip>
</div>

<br>
<hr>

<h2>Range Slider</h2>

<div style="padding: 20px;">
  <mpro-range-slider [min]="2016" [max]="2040"></mpro-range-slider>
</div>

<div style="padding: 20px;">
  <mpro-range-slider [min]="2016" [max]="2040" [disabled]="true"></mpro-range-slider>
</div>

<div style="padding: 20px;">
  <mpro-range-slider [min]="2016" [max]="2040" [arrows]="true"></mpro-range-slider>
</div>

<div style="padding: 20px;">
  <mpro-range-slider [min]="2016" [max]="2040" [arrows]="true" [disabled]="true"></mpro-range-slider>
</div>

<div style="padding: 20px;">
  <mpro-range-slider [doubleSlider]="true" [min]="2016" [max]="2040" [step]="2" [arrows]="true"></mpro-range-slider>
</div>

<br>
<hr>

<h2>Text Input</h2>

<mpro-text-input title="Label" info="text field" [dollarSign]="false" [searchSign]="true" [dropdown]="false"
  [(ngModel)]="inputValue" successMsg="Success" errorMsg="Error" placeholder="input placeholder">
</mpro-text-input>

<mpro-text-input title="Label" info="text field" [dollarSign]="true" [searchSign]="false" [dropdown]="false"
  [(ngModel)]="inputValue" successMsg="Success" errorMsg="Error" placeholder="input placeholder">
</mpro-text-input>

<mpro-text-input title="Dropdown" [dropdown]="true" [dropdownText]="false" [searchSign]="false"
  [(ngModel)]="inputValue2" placeholder="input 2 placeholder">
  <div [ngStyle]="{'display': 'flex', 'flex-direction': 'column', 'padding': '10px', 'border': '1px solid black'}">
    <mpro-checkbox label="Africa" [(ngModel)]="selected.Africa" (ngModelChange)="onChange()"></mpro-checkbox>
    <mpro-checkbox label="Asia" [(ngModel)]="selected.Asia" (ngModelChange)="onChange()"></mpro-checkbox>
    <mpro-checkbox label="Australia" [(ngModel)]="selected.Australia" (ngModelChange)="onChange()"></mpro-checkbox>
  </div>
</mpro-text-input>

<br>
<hr>

<h2>Doughnut chart</h2>

<mpro-doughnut-chart [data]="doughnutData" [colors]="['#28B869','#D78987','#F0CF90','#EDB347']"></mpro-doughnut-chart>
<mpro-doughnut-chart [data]="doughnutData2"></mpro-doughnut-chart>

<br>
<hr>

<h2>Grouped bar chart</h2>

<mpro-grouped-bar-chart #groupedChart style="width: 460px; height: 400px; display:block" [options]="options"
  [data]="chartData"></mpro-grouped-bar-chart>

<mpro-button-group>
  <button class="mpro-btn mpro-btn-primary" (click)="setSelected('female')">Female</button>
  <button class="mpro-btn mpro-btn-primary" (click)="setSelected('male')">Male</button>
  <button class="mpro-btn mpro-btn-primary" (click)="setSelected('reset')">Reset</button>
  <button class="mpro-btn mpro-btn-primary" (click)="randomizeBarData()">Randomize</button>
</mpro-button-group>
<br>
<div>Click event data: {{ clickData | json }}</div>

<br>
<br>
<br>
<hr>

<h2>Region Comparison Table</h2>

<div style="width: 45vw;">
  <mpro-region-comparison-table [selected]="selectedCountry" (checkedChange)="checkedChange($event)"
    [countries]="countries" [disabled]="disabled"></mpro-region-comparison-table>
</div>

<br>

Checked:
<ul>
  <li *ngFor="let c of checkedCountries">{{ c }}</li>
</ul>

<select [(ngModel)]="selectedCountry">
  <option [value]="undefined"></option>
  <option *ngFor="let c of countries" [value]="c.name">{{ c.name }}</option>
</select>

<br>
<br>
<br>
<hr>

<h2>Spending Distribution Table</h2>

<div style="width: 20vw;">
  <mpro-spending-distrib-breakdown-table [selected]="selectedSD" [sdData]="sdData" [total]="total">
  </mpro-spending-distrib-breakdown-table>
</div>

<br>

<select [(ngModel)]="selectedSD">
  <option [value]="undefined"></option>
  <option *ngFor="let d of sdData" [value]="d.spending_daily">{{ d.spending_daily }}</option>
</select>


<br>
<hr>

<div style="background-color: #383838; width: 7.22vw; max-width: 123px; padding: 2px; min-width: 83px;">
  <mpro-static-dropdown [title]="'Gender'" [options]="['Both', 'Female', 'Male']"></mpro-static-dropdown>
</div>

<div style="background-color: #383838; width: 15.27vw; max-width: 400px; padding: 2px; min-width: 225px;">
  <mpro-static-dropdown class="data-lens" [title]="'Data lens'"
    [options]="['National', 'Subnational - Provinces', 'Subnational - Cities']"></mpro-static-dropdown>
</div>

<div style="display: flex; flex-direction: column;">
  <mpro-checkable-dropdown-item style="width: 276px;" leftText="Sountheast Asia" rightText="(11)">
  </mpro-checkable-dropdown-item>
  <mpro-checkable-dropdown-item style="width: 276px;" leftText="Australia" [arrow]="true">
  </mpro-checkable-dropdown-item>
  <mpro-checkable-dropdown-item style="width: 276px;" leftText="Australia" [arrow]="true" [disabled]="true">
  </mpro-checkable-dropdown-item>
</div>

<div style="background-color: #383838; padding: 2px;">
  <mpro-country-and-region-selector></mpro-country-and-region-selector>
</div>

<div style="background-color: #383838;">
  <mpro-dashboard-selector [userDashboards]="[]"
    [systemDashboards]="['The World']"></mpro-dashboard-selector>
</div>
